export interface ComicComment {
  id: string;
  nickname: string;
  avatarColor: string;
  content: string;
  likes: number;
  time: string;
}

export const comicComments: ComicComment[] = [
  {
    id: 'c1',
    nickname: '炸裂星人',
    avatarColor: 'bg-primary-500',
    content: '第128话的觉醒场景也太燃了吧！主角一拳打碎玻璃幕墙的画面我反复看了三遍，这就是热血漫画的魅力！下拉阅读体验丝滑，终于找到高清无删减版本了。',
    likes: 2354,
    time: '10分钟前',
  },
  {
    id: 'c2',
    nickname: '漫画收藏家',
    avatarColor: 'bg-accent-500',
    content: '追更两年了，从第1话看到第128话，剧情越来越炸。57漫画网的更新速度是真的快，画质也清晰，必须要支持一下！',
    likes: 1876,
    time: '32分钟前',
  },
  {
    id: 'c3',
    nickname: '夜猫子读者',
    avatarColor: 'bg-secondary-500',
    content: '那个反派到底什么来头啊，看着好有压迫感！蹲一个下周的更新，希望主角能扛住这波攻势，别又断更啊哈哈。',
    likes: 1092,
    time: '1小时前',
  },
  {
    id: 'c4',
    nickname: '元气少女漫迷',
    avatarColor: 'bg-primary-700',
    content: '在虚拟漫画咖啡馆跟同好聊这部作品真的太快乐了，感觉找到了组织！推荐喜欢热血韩漫的姐妹都来一起追更～',
    likes: 866,
    time: '2小时前',
  },
];